var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#888b8d",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.123 13.676C2.599 13.17 3.293 13 4.1 13h15.8c.807 0 1.501.17 1.977.676.469.498.623 1.215.623 2.054v4.04c0 .838-.154 1.555-.623 2.054-.476.506-1.17.676-1.977.676H4.1c-.807 0-1.501-.17-1.977-.676-.469-.498-.623-1.215-.623-2.054v-4.04c0-.838.154-1.555.623-2.054zm.728.685c-.206.219-.352.617-.352 1.369v4.04c0 .752.146 1.15.352 1.369.199.212.555.361 1.248.361h15.8c.693 0 1.049-.15 1.248-.361.206-.219.352-.617.352-1.369v-4.04c0-.751-.146-1.15-.352-1.369-.199-.211-.555-.361-1.248-.361H4.1c-.693 0-1.049.15-1.248.361zM2.123 2.176C2.599 1.67 3.293 1.5 4.1 1.5h15.8c.807 0 1.501.17 1.977.676.469.498.623 1.215.623 2.054v4.04c0 .839-.154 1.555-.623 2.054-.476.506-1.17.676-1.977.676H4.1c-.807 0-1.501-.17-1.977-.676C1.654 9.825 1.5 9.109 1.5 8.27V4.23c0-.839.154-1.555.623-2.054zm.728.685c-.206.219-.352.617-.352 1.369v4.04c0 .751.146 1.15.352 1.369.199.211.555.361 1.248.361h15.8c.693 0 1.049-.15 1.248-.361.206-.219.352-.617.352-1.369V4.23c0-.751-.146-1.15-.352-1.369-.199-.211-.555-.361-1.248-.361H4.1c-.693 0-1.049.15-1.248.361z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewRow);
export default __webpack_public_path__ + "static/media/ViewRow.da24d177007efb83e20279181033c2c4.svg";
export { ForwardRef as ReactComponent };